// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"648":"016148f4","787":"61e8d9e9"}[chunkId] + ".chunk.js";
};